import { useDispatch, useSelector } from 'react-redux';
import { addItemToCart } from '../state/shop/shopSlice';
import { RootState } from '../state/store';
import { mapProductToCartItem } from '../utils/mappers/CartMapper';

export const useCart = () => {
  const state = useSelector((state: RootState) => state.cart);
  const dispatch = useDispatch();

  const cart = () => {
    return state;
  };

  const cartItems = () => {
    return state.items;
  };

  const addToCart = (product: Product) => {
    const cartItem = mapProductToCartItem(product);
    dispatch(addItemToCart(cartItem));
  };

  const cartRequirements = () => {
    return state.requirementsData;
  };

  const addAccesoiryToProduct = (productId: number, accessory: Product) => {};

  return {
    cart,
    cartItems,
    cartRequirements,
    addToCart,
  };
};
